var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _vm.$route.query.fakelogin === "true" && (_vm.isDev || _vm.isQa)
            ? _c("div", { staticClass: "btn-group dev" }, [
                _c(
                  "button",
                  {
                    staticClass: "dropdown-toggle text-primary-fh",
                    attrs: {
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [_vm._v("\n      Testning 🧰\n    ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-menu" }, [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item text-primary-fh",
                      on: {
                        click: function($event) {
                          return _vm.openDev("login")
                        }
                      }
                    },
                    [_c("strong", [_vm._v("Inloggning")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item text-primary-fh",
                      on: {
                        click: function($event) {
                          return _vm.openDev("register")
                        }
                      }
                    },
                    [_vm._v("\n        Registrering\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item text-primary-fh",
                      on: {
                        click: function($event) {
                          return _vm.clearStorages()
                        }
                      }
                    },
                    [_vm._v("\n        Rensa storages\n      ")]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dev_login
            ? _c("div", { staticClass: "m-top" }, [
                _c("div", { staticClass: "input-group" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.temp.givenName,
                        expression: "temp.givenName"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      "aria-label": "givenName",
                      placeholder: "ex: Sven"
                    },
                    domProps: { value: _vm.temp.givenName },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.temp, "givenName", $event.target.value)
                        },
                        function($event) {
                          _vm.temp.givenName = _vm.temp.givenName.replace(
                            /\s/g,
                            ""
                          )
                        }
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.temp.surName,
                        expression: "temp.surName"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      "aria-label": "surname",
                      placeholder: "ex: Andersson"
                    },
                    domProps: { value: _vm.temp.surName },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.temp, "surName", $event.target.value)
                        },
                        function($event) {
                          _vm.temp.surName = _vm.temp.surName.replace(/\s/g, "")
                        }
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.temp.invitationLink,
                        expression: "temp.invitationLink"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      "aria-label": "invitationLink",
                      placeholder: "ex: a9fb8545-22b7-4d6d-8d4c-bcef212a6153"
                    },
                    domProps: { value: _vm.temp.invitationLink },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.temp,
                            "invitationLink",
                            $event.target.value
                          )
                        },
                        function($event) {
                          _vm.temp.invitationLink = _vm.temp.invitationLink.replace(
                            /\s/g,
                            ""
                          )
                        }
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.temp.ssn,
                        expression: "temp.ssn"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      "aria-label": "ssn",
                      placeholder: "ex: 198010101234"
                    },
                    domProps: { value: _vm.temp.ssn },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.temp, "ssn", $event.target.value)
                        },
                        function($event) {
                          _vm.temp.ssn = _vm.temp.ssn.replace(/\s/g, "")
                        }
                      ],
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.relativeLogin()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-info btn-md btn-block",
                  attrs: {
                    type: "button",
                    disabled:
                      !_vm.temp.givenName || !_vm.temp.surName || !_vm.temp.ssn,
                    value: "Logga in"
                  },
                  on: {
                    click: function($event) {
                      return _vm.relativeLogin()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("div", { staticClass: "alert alert-info div-loader" }, [
                  _vm._v("Laddar")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "alert alert-danger alert-error" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.dev_register
            ? _c("div", { staticClass: "m-top" }, [
                _c("div", { staticClass: "input-group" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.temp.ssn,
                        expression: "temp.ssn"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      "aria-label": "ssn",
                      placeholder: "ex: 198010101234"
                    },
                    domProps: { value: _vm.temp.ssn },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.temp, "ssn", $event.target.value)
                        },
                        function($event) {
                          _vm.temp.ssn = _vm.temp.ssn.replace(/\s/g, "")
                        }
                      ]
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.temp.invitationLink,
                        expression: "temp.invitationLink"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      "aria-label": "invitationLink",
                      placeholder: "ex: a9fb8545-22b7-4d6d-8d4c-bcef212a6153"
                    },
                    domProps: { value: _vm.temp.invitationLink },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.temp,
                            "invitationLink",
                            $event.target.value
                          )
                        },
                        function($event) {
                          _vm.temp.invitationLink = _vm.temp.invitationLink.replace(
                            /\s/g,
                            ""
                          )
                        }
                      ],
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.relativeRegister()
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-info btn-md btn-block",
                  attrs: {
                    type: "button",
                    disabled:
                      !_vm.temp.ssn || !_vm.temp.invitationLink || !_vm.isGuid,
                    value: "Registrera"
                  },
                  on: {
                    click: function($event) {
                      return _vm.relativeRegister()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c("div", { staticClass: "alert alert-info div-loader" }, [
                  _vm._v("Laddar")
                ]),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _vm._m(7)
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: require("@/assets/img/family.svg?data"),
                    alt: "Bild på familj"
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img-fluid img-logo-xl",
                  attrs: {
                    src: require("@/assets/img/logo.svg?data"),
                    alt: "FHabian.nu logotyp"
                  }
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("h1", {
                  staticClass: "text-primary-fh",
                  domProps: {
                    innerHTML: _vm._s(_vm.data.startpage.welcomeHeader)
                  }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.data.startpage.welcomeText)
                  }
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.data.landingpage.alreadyregisteredtext
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.relativeAlreadyRegistered,
                        expression: "relativeAlreadyRegistered"
                      }
                    ],
                    staticClass: "alert alert-info",
                    attrs: { id: "relativeAlreadyRegistered" }
                  },
                  [
                    _vm._v(
                      "\n          Du är redan registrerad, vänligen logga in som vanligt nedan.\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.showHelp
                  ? _c("small", { staticClass: "text-muted" }, [
                      _vm._v("Format: "),
                      _c("i", [_vm._v("YYYYMMDDXXXX")])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix--min" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.loginWithBankId()
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        src: require("@/assets/img/bankid-btn.svg?data"),
                        alt: "Knapp för inloggning med BankID"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.loginWithFreja()
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        src: require("@/assets/img/freja-btn.svg?data"),
                        alt: "Knapp för inloggning med Freja eID"
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "text-content" }, [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.startpage.ageClarificationText)
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: require("@/assets/img/tree-prototype.svg?data"),
                    alt: "Bild på en släktträdsprototyp"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "text-content" }, [
                  _c("h4", {
                    staticClass: "text-danger",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.startpage.whatisfhHeader)
                    }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.startpage.whatisfhText)
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-content" }, [
                  _c("h4", {
                    staticClass: "text-danger",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.startpage.howtotreatfhHeader)
                    }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.startpage.howtotreatfhText)
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("förnamn")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("efternamn")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("invitelänk")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("ssn/pnr")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("ssn/pnr")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("invitelänk")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-danger alert-error" }, [
      _c("strong", [_vm._v("Något fält är fel, försök igen")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-success alert-reg" }, [
      _c("strong", [_vm._v("Registrering lyckades")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f092191", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f092191","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartPage.vue
// module id = null
// module chunks = 